// Importér dashboard-sprogobjekter
import dashboardDanish from './danish/dashboard';
import dashboardEnglish from './english/dashboard';
import dashboardNorwegian from './norwegian/dashboard';
import dashboardSwedish from './swedish/dashboard';

// Importér menu-sprogobjekter
import menuDanish from './danish/menu';
import menuEnglish from './english/menu';
import menuNorwegian from './norwegian/menu';
import menuSwedish from './swedish/menu';

// Importér settings-sprogobjekter
import settingsDanish from './danish/settings';
import settingsEnglish from './english/settings';
import settingsNorwegian from './norwegian/settings';
import settingsSwedish from './swedish/settings';

// Importér posts-sprogobjekter
import postsDanish from './danish/posts';
import postsEnglish from './english/posts';
import postsNorwegian from './norwegian/posts';
import postsSwedish from './swedish/posts';

// Importér scheduler-sprogobjekter
import schedulerDanish from './danish/scheduler';
import schedulerEnglish from './english/scheduler';
import schedulerNorwegian from './norwegian/scheduler';
import schedulerSwedish from './swedish/scheduler';

// Importér callback-sprogobjekter
import callbackDanish from './danish/callback';
import callbackEnglish from './english/callback';
import callbackNorwegian from './norwegian/callback';
import callbackSwedish from './swedish/callback';

// Importér billedearkiv-sprogobjekter
import imageArchiveDanish from './danish/imageArchive';
import imageArchiveEnglish from './english/imageArchive';
import imageArchiveNorwegian from './norwegian/imageArchive';
import imageArchiveSwedish from './swedish/imageArchive';

// Importér ai indstillinger-sprogobjekter
import aiPromptSettingsDanish from './danish/aiPromptSettings';
import aiPromptSettingsEnglish from './english/aiPromptSettings';
import aiPromptSettingsNorwegian from './norwegian/aiPromptSettings';
import aiPromptSettingsSwedish from './swedish/aiPromptSettings';

// Importér organization-sprogobjekter
import organizationDanish from './danish/organization';
import organizationEnglish from './english/organization';
import organizationNorwegian from './norwegian/organization';
import organizationSwedish from './swedish/organization';

// Importér CaseGenerator-sprogobjekter
import caseGeneratorDanish from './danish/caseGenerator';
import caseGeneratorEnglish from './english/caseGenerator';
import caseGeneratorNorwegian from './norwegian/caseGenerator';
import caseGeneratorSwedish from './swedish/caseGenerator';

// Importér AIGenerator-sprogobjekter
import aiGeneratorDanish from './danish/aiGenerator';
import aiGeneratorEnglish from './english/aiGenerator';
import aiGeneratorNorwegian from './norwegian/aiGenerator';
import aiGeneratorSwedish from './swedish/aiGenerator';

// Importér LinkedInPoster-sprogobjekter
import linkedInPosterDanish from './danish/linkedInPoster';
import linkedInPosterEnglish from './english/linkedInPoster';
import linkedInPosterNorwegian from './norwegian/linkedInPoster';
import linkedInPosterSwedish from './swedish/linkedInPoster';

// Importér SubscriptionPlans-sprogobjekter
import subscriptionPlansDanish from './danish/subscriptionPlans';
import subscriptionPlansEnglish from './english/subscriptionPlans';
import subscriptionPlansNorwegian from './norwegian/subscriptionPlans';
import subscriptionPlansSwedish from './swedish/subscriptionPlans';

// Saml alle sprogobjekter i ét objekt
const translations = {
  danish: {
    dashboard: dashboardDanish,
    menu: menuDanish,
    settings: settingsDanish,
    posts: postsDanish,
    scheduler: schedulerDanish,
    callback: callbackDanish,
    imageArchive: imageArchiveDanish,
    aiPromptSettings: aiPromptSettingsDanish,
    organization: organizationDanish,
    caseGenerator: caseGeneratorDanish,
    aiGenerator: aiGeneratorDanish,
    linkedInPoster: linkedInPosterDanish,
    subscriptionPlans: subscriptionPlansDanish
    // Andre sider kan tilføjes her efterhånden som de bliver oversat
  },
  english: {
    dashboard: dashboardEnglish,
    menu: menuEnglish,
    settings: settingsEnglish,
    posts: postsEnglish,
    scheduler: schedulerEnglish,
    callback: callbackEnglish,
    imageArchive: imageArchiveEnglish,
    aiPromptSettings: aiPromptSettingsEnglish,
    organization: organizationEnglish,
    caseGenerator: caseGeneratorEnglish,
    aiGenerator: aiGeneratorEnglish,
    linkedInPoster: linkedInPosterEnglish,
    subscriptionPlans: subscriptionPlansEnglish
    // Andre sider kan tilføjes her efterhånden som de bliver oversat
  },
  norwegian: {
    dashboard: dashboardNorwegian,
    menu: menuNorwegian,
    settings: settingsNorwegian,
    posts: postsNorwegian,
    scheduler: schedulerNorwegian,
    callback: callbackNorwegian,
    imageArchive: imageArchiveNorwegian,
    aiPromptSettings: aiPromptSettingsNorwegian,
    organization: organizationNorwegian,
    caseGenerator: caseGeneratorNorwegian,
    aiGenerator: aiGeneratorNorwegian,
    linkedInPoster: linkedInPosterNorwegian,
    subscriptionPlans: subscriptionPlansNorwegian
    // Andre sider kan tilføjes her efterhånden som de bliver oversat
  },
  swedish: {
    dashboard: dashboardSwedish,
    menu: menuSwedish,
    settings: settingsSwedish,
    posts: postsSwedish,
    scheduler: schedulerSwedish,
    callback: callbackSwedish,
    imageArchive: imageArchiveSwedish,
    aiPromptSettings: aiPromptSettingsSwedish,
    organization: organizationSwedish,
    caseGenerator: caseGeneratorSwedish,
    aiGenerator: aiGeneratorSwedish,
    linkedInPoster: linkedInPosterSwedish,
    subscriptionPlans: subscriptionPlansSwedish
    // Andre sider kan tilføjes her efterhånden som de bliver oversat
  }
};

// Liste af tilgængelige sprog
export const availableLanguages = [
  { code: 'danish', name: 'Dansk' },
  { code: 'english', name: 'English' },
  { code: 'norwegian', name: 'Norsk' },
  { code: 'swedish', name: 'Svenska' }
];

export default translations; 